<template>
  <div id="nav">
    <!-- <router-link to="/"></router-link> -->
    <!-- <router-view/> -->
    <!-- <img src="img/zhuk.png" width="71" height="164" alt="Меню" /> -->
  </div>
  <router-view/>
</template>